import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=63241b32&scoped=true&"
import script from "./Decline.vue?vue&type=script&lang=ts&"
export * from "./Decline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63241b32",
  null
  
)

export default component.exports